<!-- <footer class="footer">
  © CTLogPlus® Todos los derechos reservados, <a href="https://www.calltechsa.com/wordpress/wp-content/uploads/2020/09/Licencia-de-uso-de-Sofftware-Calltech-S.A..pdf"
                                                 target="_blank"
                                                 style="color: #b7c6ce">Calltech S.A</a>.
</footer> -->
<footer class="footer">
  V 1.0.7 © CTLogPlus® Todos los derechos reservados, <a href="https://www.calltechsa.com/licencia-de-software/"
                                                 target="_blank"
                                                 style="color: #b7c6ce">Calltech S.A</a>.
</footer>
